import { render } from "./Checker.vue?vue&type=template&id=28f2fcd2"
import script from "./Checker.vue?vue&type=script&lang=js"
export * from "./Checker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__